import _Timeline from './Timeline';
import _TimelineItem from './TimelineItem';

import './style/index.js';

export type { TimelineProps } from './Timeline';
export type { TimelineItemProps } from './TimelineItem';

export const Timeline = _Timeline;
export const TimelineItem = _TimelineItem;

export default Timeline;
